import { Navigate } from 'react-router-dom';

import useAuthStore from '../../store/auth';

interface UnprotectedRoutesPros {
  children: JSX.Element;
}

export const UnprotectedRoutes = ({ children }: UnprotectedRoutesPros) => {
  const signed = useAuthStore(state => state.signed);
  const user = useAuthStore(state => state.user);
  // const companies = useCompanyStore(state => state.companies);

  if (signed && user?.profile === 'UN1') {
    return <Navigate to="/home/contas" />;
  }

  if (
    signed &&
    (user?.profile === 'UN2' ||
      user?.profile === 'UN3' ||
      user?.profile === 'UN4')
  ) {
    return <Navigate to="/home/reunioes" />;
  }

  return children;
};
